<div class="valor text-center">{{ valor }}</div>
<div class="container">
	<div class="barraValorPercentual bg-blue-60" #barraValorPercentual></div>
	<div class="barraValorResidual bg-gray-20" #barraValorResidual></div>
</div>
